import { TItemDescriptions } from 'factions/factionTypes'
import { tagAs } from 'factions/metatagger'
import {
  BATTLESHOCK_PHASE,
  COMBAT_PHASE,
  HERO_PHASE,
  SAVES_PHASE,
  SHOOTING_PHASE,
  WOUND_ALLOCATION_PHASE,
} from 'types/phases'

const Prayers = {
  'Prayers of the Khainite Cult': {
    effects: [
      {
        name: `Catechism of Murder: Chant value of 3 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Daughters of Khaine Priest to chant this prayer, pick a visible friendly Daughters of Khaine unit wholly within 12" of them to be the target, then make a chanting roll of D6. 
        Effect: The target's melee weapons have Crit (Auto-wound) until the start of your next turn. In addition, if the chanting roll was 7+, the targets combat attacks score critical hits on unmodified hit rolls of 5+ until the start of your next turn.`,
        when: [HERO_PHASE],
      },
      {
        name: `Dance of Doom: Chant value of 4`,
        desc: `Declare: Pick a friendly Daughters of Khaine Priest to chant this prayer, pick a visible friendly non-Unique Daughters of Khaine unit wholly within 12" of them to be the target, then make a chanting roll of D6. 
        Effect: Add 1 to the Attacks characteristic of the target's melee weapons for the rest of the turn. In addition, if the chanting roll was 10+, the target can use 2 Fight abilities this turn. After the first is used, however, the target has Strike-Last for the rest of the turn.`,
        when: [HERO_PHASE],
      },
      {
        name: `Covenant of the Iron Heart: Chant value of 3`,
        desc: `Declare: Pick a friendly Daughters of Khaine Priest to chant this prayer, pick a visible friendly Daughters of Khaine unit wholly within 12" of them to be the target, then make a chanting roll of D6. 
        Effect: Add 10 to the target's control score until the start of your next turn. In addition, if the chanting roll was 6+, ignore the first damage point that would be allocated to the target in each phase until the start of your next turn.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Bloodshadow Rites': {
    effects: [
      {
        name: `Shadowstep: Chant value of 3 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Daughters of Khaine Priest to chant this prayer, pick a visible friendly Daughters of Khaine Aelf Infantry unit wholly within 12" of them and that has not been picked to be the target of this prayer this turn to be the target, then make a chanting roll of D6. 
        Effect: The target can move up to 6". It can move through the combat ranges of enemy units but cannot end that move in combat. If the chanting roll was 8+, you can pick another eligible unit to be a second target.`,
        when: [HERO_PHASE],
      },
      {
        name: `Scathscale: Chant value of 3`,
        desc: `Declare: Pick a friendly Daughters of Khaine Priest to chant this prayer, pick a friendly Daughters of Khaine Aelf Infantry unit wholly within 12" of them to be the target, then make a chanting roll of D6. 
        Effect: Until the start of your next turn, subtract 1 from wound rolls for combat attacks that target that friendly unit. If the chanting roll was 8+, until the start of your next turn, subtract 1 from wound rolls for combat attacks that target friendly Daughters of Khaine Aelf Infantry units while they are wholly within 12" of the target of this ability instead.`,
        when: [HERO_PHASE],
      },
      {
        name: `Exultation of Murder: Chant value of 4`,
        desc: `Declare: Pick a friendly Daughters of Khaine Priest to chant this prayer, pick a friendly Daughters of Khaine Aelf Infantry unit wholly within 12" of them to be the target, then make a chanting roll of D6. 
        Effect: Until the start of your next turn, add 1 to wound rolls for the targets combat attacks. In addition, if the chanting roll was 9+, until the start of your next turn, add 1 to the Attacks characteristic of the targets melee weapons.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'The Croneseers Pariahs (AoR)': {
    effects: [
      {
        name: `Wings of the Crone Goddess: Chant value of 3 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Croneseers Pariahs Priest to chant this prayer, pick a visible friendly Croneseers Pariahs unit wholly within 12" of them to be the target, then make a chanting roll of D6. 
        Effect: Until the start of your next turn: 
        The target has Fly. 
        Add 2" to the targets Move characteristic. If the chanting roll was 8+, add 6" to the targets Move characteristic instead.`,
        when: [HERO_PHASE],
      },
      {
        name: `Augury of Battle: Chant value of 5`,
        desc: `Declare: Pick a friendly Croneseers Pariahs Priest to chant this prayer, pick a visible friendly Croneseers Pariahs unit wholly within 18" of them to be the target, then make a chanting roll of D6. 
        Effect: Until the start of your next turn, the target has Ward (5+). If the chanting roll was 10+, you can pick up to 2 friendly Croneseers Pariahs units wholly within 18" of the caster instead of 1.`,
        when: [HERO_PHASE],
      },
      {
        name: `Auspicious Strike: Chant value of 4`,
        desc: `Declare: Pick a friendly Croneseers Pariahs Priest to chant this prayer, pick a visible friendly Croneseers Pariahs unit wholly within 12" of them to be the target, then make a chanting roll of D6. 
        Effect: Until the start of your next turn, each time the unmodified hit roll for an attack made against the target is 1, inflict 1 mortal damage on the attacking unit after the Fight ability has been resolved. If the chanting roll was 10+, inflict 1 mortal damage for each unmodified hit roll of 1-2 instead.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Champions of the Arena (AoR)': {
    effects: [
      {
        name: `Divine Rush: Chant value of 3 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Champions of the Arena Priest to chant this prayer, pick a visible friendly Champions of the Arena unit wholly within 12" of them to be the target, then make a chanting roll of D6. 
        Effect: If the chanting roll was a 6+, you can pick another eligible unit to be a second target.
        For each target:
        IF the target is not in combat, it can move D6". It cannot end that move in combat.
        If the target is in combat, it can make a pile-in move.`,
        when: [HERO_PHASE],
      },
      {
        name: `Call of the Arena: Chant value of 3`,
        desc: `Declare: Pick a friendly Champions of the Arena Priest to chant this prayer, then make a chanting roll of D6. 
        Effect: For the rest of the turn, add 1 to run rolls for friendly Champions of the Arena units while they are wholly within 12" of the chanter. In addition, if the chanting roll was 6+, for the rest of the turn, add 1 to charge rolls for friendly Champions of the Arena units while they are wholly within 12" of the chanter.`,
        when: [HERO_PHASE],
      },
      {
        name: `Shield of Blood: Chant value of 3`,
        desc: `Declare: Pick a friendly Champions of the Arena Priest to chant this prayer, pick a visible friendly Champions of the Arena unit wholly within 12" of them to be the target, then make a chanting roll of D6. 
        Effect: If the chanting roll was 10+, you can pick up to 2 other eligible units to be additional targets. Each target has Ward (5+) until the start of your next turn.`,
        when: [HERO_PHASE],
      },
      {
        name: `Violent Consecration: Chant value of 4`,
        desc: `Declare: Pick a friendly Champions of the Arena Priest to chant this prayer, pick 1 of the friendly Manifestations below that is not on the battlefield, then make a chanting roll D6.
        Bloodwrack Viper
        Bladewind
        Heart of Fury 
        Effect: If you picked a Bloodwrack Viper or Bladewind, set it up wholly within 12" of the chanter, visible to them and more thena 9" from all enemy units. If you picked a Heart of Fury, set it up wholly within 18" of the chanter and visible to them. If the chanting roll was 10+, you can pick a second Manifestation from the list above that is not on the battlefield and set it up as described above.`,
        when: [HERO_PHASE],
      },
      {
        name: `Bladewind - Unnatural Edge`,
        desc: `Declare: If this Manifestation charged this turn, pick an enemy unit in combat with it to be the target. 
        Effect: If any damage points are allocated to the target this phase by this Manifestation's combat attacks, ward rolls cannot be made for the target for the rest of the battle.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Bloodwrack Viper - Crushing Coils`,
        desc: `Declare: Pick an enemy Hero  or Monster in combat with this Manifestation to be the target. 
        Effect: Roll a dice. On a 3+, the target has Strike-Last for the rest of the turn.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Bloodwrack Viper - Bind and Bite - Passive`,
        desc: `Effect: This unit's combat attacks score critical hits on unmodified hit rolls of 4+ if the target of those attacks has Strike-Last.`,
        when: [COMBAT_PHASE],
      },

      {
        name: `Heart of Fury - Locus of the Murder God - Passive`,
        desc: `Effect: Subtract 1 from wound rolls for attacks that target friendly Daughters of Khaine Infantry units while they are wholly within 12" of this Manifestation.`,
        when: [SHOOTING_PHASE, COMBAT_PHASE],
      },
    ],
  },
} satisfies TItemDescriptions

export default tagAs(Prayers, 'prayer')
